import React, { Component } from "react";
import { Message } from "semantic-ui-react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { confirm } from "../../../actions/user";

class ConfirmationPage extends Component {
	state = {
		loading: true,
		success: false
	};

	componentDidMount() {
		this.props
			.confirm(this.props.match.params.token)
			.then(() => this.setState({ loading: false, success: true }))
			.catch(() => this.setState({ loading: false, success: false }));
	}

	render() {
		const { loading, success } = this.state;

		return (
			<div>
				{loading && (
					<Message>
						<Message.Header>Validating your email</Message.Header>
					</Message>
				)}

				{!loading &&
					success && (
						<Message success>
							<Message.Header>Thankyou, you are now verified</Message.Header>
							<Link to="/">Return home</Link>
						</Message>
					)}

				{!loading &&
					!success && (
						<Message success>
							<Message.Header>Invalid token</Message.Header>
						</Message>
					)}
			</div>
		);
	}
}

ConfirmationPage.propTypes = {
	confirm: PropTypes.func.isRequired,
	match: PropTypes.shape({
		params: PropTypes.shape({
			token: PropTypes.string.isRequired
		}).isRequired
	}).isRequired
};

export default connect(null, { confirm })(ConfirmationPage);



// WEBPACK FOOTER //
// ./src/components/pages/confirmationPage/confirmationPage.js